<style>
.bg-primary {
  background-color: #1a3665 !important;
}
</style>
<template>
    <CCard>
      <CCardHeader
      class="bg-primary text-white border-0 font-weight-bold p-3 d-flex align-items-center justify-content-between"> Instruktur RPL
      <router-link to="instruktur-rpl/tambah">
        <CButton color="success" class="btn-md">Tambah</CButton>
      </router-link>
    </CCardHeader>
      <!-- Data Instruktur RPL -->
      <CCardBody ref="mycardloader">
        <CRow>
          <div class="col-sm-12 col-xl-2">
            <div class="form-group">
              <CSelect
                label="Data Perhalaman"
                class="float-left"
                @change="changePageSize"
                :options="[10, 25, 100, 'Semua Data']"
              />
            </div>
          </div>
          <div class="col-sm-12 col-xl-3 ml-auto">
            <div class="form-group">
              <label for>Pencarian</label>
              <input
                type="text"
                nama
                id
                class="form-control"
                placeholder="Cari Data ..."              
                v-model="search"
              />
            </div>
          </div>
        </CRow>
        <CRow>
          <CCol lg="12" class="table-responsive">
            <CDataTable style="widht:100% !important" :items="items" :fields="fields" hover sorter>
              <template #no="{ index}">
                <td class="py-2">{{ index+1 }}</td>
              </template>
              <template #cv="{item}">
                <td class="py-2">
                  <a v-if="item.cv != '' && item.cv != null" :href="baseUrl+'/uploads/sertifikasi/master_rpl/instruktur_rpl_cv/'+item.cv"
                        target="_blank"
                  >
                    <CButton color="info" class="btn-sm" square>
                        <font-awesome-icon icon="file" style="font-color:white;" />
                    </CButton>
                  </a>
                  <a v-else
                      @click="dataTidakAda()"
                  >
                    <CButton color="info" class="btn-sm" square>
                        <font-awesome-icon icon="file" style="font-color:white;" />
                    </CButton>
                  </a>
                </td>
              </template>
              <template #status="{item}">
                <td class="py-2 text-center">
                  <font-awesome-icon icon="check" class="text-success" v-if="item.status == 1" />
                  <font-awesome-icon icon="times" class="text-danger" v-else />
                </td>
              </template>
              <template #aksi="{item, index}">
                <td class="py-2 text-center">
                  <router-link :to="'/rpl/instruktur-rpl/edit/'+item.idInstrukturRpl">
                    <CButton v-c-tooltip="'Ubah'" color="info" class="btn-sm" square>
                      <font-awesome-icon icon="edit" />
                    </CButton>
                  </router-link>&nbsp;&nbsp;
                  <CButton v-c-tooltip="'Hapus'" color="danger" class="btn-sm" square @click="deleteData(item, index)">
                    <font-awesome-icon icon="trash" />
                  </CButton>
                </td>
              </template>
            </CDataTable>
            <CPagination
              style="float:right"
              :active-page.sync="currentPage"
              :pages="pagination.totalPages"
              responsive
              @click="pageChange"
            />
          </CCol>
        </CRow>
      </CCardBody>
      <!-- End Data Instruktur RPL -->
    </CCard>
</template>
<script>
import InstrukturRplService from "../../../services/sertifikasi/master-rpl-instruktur.service";
import baseUrl from "../../../services/base-url";
import { AlertUtils } from "../../../mixins/AlertUtils";
import { Pagination } from "../../../mixins/Pagination";

const fields = [
  {
    key: "no",
    sorter: true,
    filter: false
  },
  {
    key: "nama",
    label: "Nama",
    sorter: true,
    filter: false
  },
  {
    key: "alamat",
    label: "Alamat",
    sorter: true,
    filter: false
  },
  {
    key: "noTelephone",
    label: "No Telepon",
    sorter: true,
    filter: false
  },
  {
    key: "email",
    label: "Email",
    sorter: true,
    filter: false
  },
  {
    key: "instansi",
    label: "Instansi",
    sorter: true,
    filter: false
  },
  {
    key: "cv",
    label: "CV",
    sorter: false,
    filter: false
  },
  {
    key: "status",
    _style: "text-align: center",
    sorter: false,
    filter: false
  },
  {
    key: "aksi",
    _style: "width:12%; text-align: center",
    sorter: false,
    filter: false
  }
];

export default {
  mixins: [AlertUtils, Pagination],
  data() {
    return {      
      actionPost: "",
      formData: {
        idInstrukturRpl: "",
        cv:""
      },      
      baseUrl:"",
      fields,      
      details: [],      
      status: false,
      myModal: false,
      horizontal: { label: "col-3", input: "col-9" },
      collapseDuration: 0,
      content: []
    };
  },
  mounted() {

    this.getData("0", this.pageSize, this.search);
    this.baseUrl = baseUrl();

    $(function() {
      $('input[name="daterange"]').daterangepicker(
        {
          opens: "auto",
          autoApply: true,
          singleDatePicker: true
        },
        function(start, end, label) {
          // comment console console.log(
            
        }
      );
    });
  },

  methods: {    

    pageChange() {
      this.getData(currentPage);
    },

    cekFile(){
            if (this.formData.cv != '' && this.formDataitem.cv != null) {
                let routeData = this.baseUrl+'/uploads/sertifikasi/master_rpl/instruktur_rpl_cv/'+this.formData.cv;
                window.open(routeData, '_blank');
            } else{
                this.$swal.fire({
                    title: "Informasi",
                    text: 'File Tidak Ditemukan.',
                    icon: "info",
                    confirmButtonText: 'Tutup',
                    showConfirmButton: true,
                });
            }
    },

    dataTidakAda(){
      this.$swal.fire({
          title: "Informasi",
          text: 'File Tidak Ditemukan.',
          icon: "info",
          confirmButtonText: 'Tutup',
          showConfirmButton: true,
      });
    },

    deleteData(item, index) {
      var vm = this;
      this.formData = item;

      this.$swal
        .fire({
          title: "Peringatan!",
          text: "Apakah anda yakin ingin menghapus data ini ?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Ya",
          cancelButtonText: "Tidak",
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          reverseButtons: true
        })

        .then(result => {
          if (result.value) {
            InstrukturRplService.deleteInstrukturRpl(vm.formData)
              .then(response => {

                vm.alertSuccess();

                this.getData("0", this.pageSize, this.search);
              })

              .catch(error => {
                vm.alertError();
              });
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            vm.$swal.fire(
              "Cancelled",
              "Your imaginary file is safe :)",
              "error"
            );
          }
        });
    },

    getData(currentPage, pageSize, filter) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.mycardloader,
        canCancel: true,
        onCancel: this.onCancel
      });
      var vm = this;
      InstrukturRplService.getInstrukturRpl(currentPage, pageSize, filter)
        .then(response => {
          loader.hide();
          vm.items = response.data.data.content;

          vm.pagination.totalPages = response.data.data.totalPages;
          vm.currentPage = response.data.data.pageable.pageNumber + 1;

          setTimeout(() => loader.hide(), 1000);
        })
        .catch(error => {
          // comment console console.log(error);
        });
    },
  }
};
</script>